import { Theme } from '@material-ui/core';

const getSpacingHelpers = (theme: Theme) => {
  const sides = [ 't', 'r', 'b', 'l', 'x', 'y', '' ];
  const sizes = [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 'auto' ];
  const properties = [ 'margin', 'padding' ];
  const polarities = [ '', 'n' ];
  const classes: any = {};
  sides.forEach(
    (side) => sizes.forEach(
      (size) => properties.forEach(
        (prop) => polarities.forEach(
          (polarity) => {
            // auto only in margin left, right and horizontal (x)
            if (size === 'auto' && (prop[0] !== 'm' || polarity || !side)) return;
            // negative only in margin and size !== 0 (auto is handled in previous if)
            if (polarity === 'n' && (prop[0] !== 'm' || size === 0)) return;
            const obj: any = {};
            // size 3 === theme.spacing, polarity makes number negative
            const value = `${typeof size === 'string' ? size : `${Math.round(size * theme.spacing()) * (polarity ? -1 : 1)}px`
            } !important`; // win specificity
            if (!side || side === 'y' || side === 't') obj[`${prop}BlockStart`] = value;
            if (!side || side === 'x' || side === 'l') obj[`${prop}InlineStart`] = value;
            if (!side || side === 'x' || side === 'r') obj[`${prop}InlineEnd`] = value;
            if (!side || side === 'y' || side === 'b') obj[`${prop}BlockEnd`] = value;
            // class construction
            classes[`.${prop[0]}${side}-${polarity}${size}`] = obj;
          },
        ),
      ),
    ),
  );
  return classes;
};

export default getSpacingHelpers;
